import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./styles/AdminAttendance.css";

const backendUrl = "https://sokonishushi.co.tz/api";

export default function AdminAttendance() {
    const [user, setUser] = useState(null);
    const [attendanceData, setAttendanceData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedAttendance, setSelectedAttendance] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const userData = {
            names: localStorage.getItem("names"),
            role: localStorage.getItem("role"),
            staff_id: localStorage.getItem("staff_id")
        };
        setUser(userData);
        fetchAttendanceData();
    }, []);

    const fetchAttendanceData = async () => {
        try {
            const response = await fetch(`${backendUrl}/attendance.php`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success) {
                setAttendanceData(data.attendance);
            }
        } catch (error) {
            console.error("Error fetching attendance:", error);
        } finally {
            setLoading(false);
        }
    };

    const viewDetails = (record) => {
        setSelectedAttendance(record);
        setShowModal(true);
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    if (loading) {
        return (
            <div className="admin-attendance-loading">
                <div className="spinner"></div>
                <p>Loading attendance records...</p>
            </div>
        );
    }

    return (
        <div className="admin-attendance-container">
            {/* Sidebar */}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <h2>Attendance System</h2>
                    <div className="user-info">
                        <div className="user-name">{user?.names || 'Admin'}</div>
                        <div className="user-role admin">Admin</div>
                    </div>
                </div>
                <nav className="sidebar-nav">
                    <Link to="/dashboard" className="nav-link">📊 Overview</Link>
                    <Link to="/attendance" className="nav-link active">📍 Attendance Records</Link>
                    <Link to="/schedule" className="nav-link">📅 Schedule</Link>
                    <Link to="/reports" className="nav-link">📄 Reports</Link>
                    <button onClick={handleLogout} className="nav-link logout">🚪 Logout</button>
                </nav>
            </aside>

            {/* Main Content */}
            <main className="admin-attendance-main">
                <div className="attendance-header">
                    <h1>Attendance Records</h1>
                    <p>View all staff sign-in and sign-out records</p>
                </div>

                {/* Stats Summary */}
                <div className="stats-summary">
                    <div className="summary-card">
                        <div className="summary-number">{attendanceData.length}</div>
                        <div className="summary-label">Total Records</div>
                    </div>
                    <div className="summary-card">
                        <div className="summary-number">
                            {attendanceData.filter(a => a.action === 'sign_in').length}
                        </div>
                        <div className="summary-label">Sign Ins</div>
                    </div>
                    <div className="summary-card">
                        <div className="summary-number">
                            {attendanceData.filter(a => a.action === 'sign_out').length}
                        </div>
                        <div className="summary-label">Sign Outs</div>
                    </div>
                </div>

                {/* Attendance Table */}
                <div className="table-container">
                    <table className="attendance-table">
                        <thead>
                            <tr>
                                <th>Staff Name</th>
                                <th>Phone Number</th>
                                <th>Action</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attendanceData.length > 0 ? (
                                attendanceData.map((record) => (
                                    <tr key={record.id}>
                                        <td>{record.staff_name}</td>
                                        <td>{record.phonenumber}</td>
                                        <td>
                                            <span className={`action-badge ${record.action}`}>
                                                {record.action === 'sign_in' ? 'Sign In' : 'Sign Out'}
                                            </span>
                                        </td>
                                        <td>{record.sign_date}</td>
                                        <td>{record.sign_time}</td>
                                        <td>
                                            <span className="status-badge completed">Completed</span>
                                        </td>
                                        <td>
                                            <button className="view-btn" onClick={() => viewDetails(record)}>
                                                View Details
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="empty-message">No attendance records found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </main>

            {/* Modal for Viewing Details */}
            {showModal && selectedAttendance && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>Attendance Details</h2>
                            <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <div className="detail-row">
                                <strong>Staff Name:</strong> {selectedAttendance.staff_name}
                            </div>
                            <div className="detail-row">
                                <strong>Phone Number:</strong> {selectedAttendance.phonenumber}
                            </div>
                            <div className="detail-row">
                                <strong>Action:</strong> 
                                <span className={`action-badge ${selectedAttendance.action}`}>
                                    {selectedAttendance.action === 'sign_in' ? 'Sign In' : 'Sign Out'}
                                </span>
                            </div>
                            <div className="detail-row">
                                <strong>Date:</strong> {selectedAttendance.sign_date}
                            </div>
                            <div className="detail-row">
                                <strong>Time:</strong> {selectedAttendance.sign_time}
                            </div>
                            <div className="detail-row">
                                <strong>Location:</strong>
                                {selectedAttendance.latitude && selectedAttendance.longitude ? (
                                    <a 
                                        href={`https://www.google.com/maps?q=${selectedAttendance.latitude},${selectedAttendance.longitude}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="map-link"
                                    >
                                        View on Map
                                    </a>
                                ) : 'N/A'}
                            </div>
                            <div className="detail-row">
                                <strong>Selfie Image:</strong>
                                <div className="selfie-image">
                                    <img 
                                        src={`https://sokonishushi.co.tz/${selectedAttendance.selfie_image}`}
                                        alt="Selfie"
                                        onError={(e) => e.target.src = '/placeholder.png'}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}